// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textarea__WvaLlDtGlVJ07","red":"red__g8+Ix93OlGzgh"};